import { Link } from 'react-router-dom';

export default function Cautions() {
  const cautions = [
    {
      icon: 'ri-calendar-check-line',
      title: 'ポイント有効期限に注意',
      description: 'ポイントには有効期限があります。せっかく貯めたポイントを失効させないよう、定期的に確認して使いましょう。',
      solution: '有効期限が近いポイントから優先的に使う、自動交換設定を活用する'
    },
    {
      icon: 'ri-exchange-line',
      title: 'ポイント交換レートを確認',
      description: 'ポイントの交換先によって、1ポイントの価値が変わることがあります。最もお得な交換先を選びましょう。',
      solution: '交換レート1ポイント=1円以上の交換先を選ぶ、キャンペーン時に交換する'
    },
    {
      icon: 'ri-shield-check-line',
      title: '条件達成の確認',
      description: '高還元率を受けるには、特定の条件（タッチ決済、アプリ登録など）が必要な場合があります。',
      solution: '事前に条件を確認し、必要な設定を済ませておく'
    },
    {
      icon: 'ri-wallet-3-line',
      title: '使いすぎに注意',
      description: 'ポイント目当てで不要な買い物をしては本末転倒です。必要なものだけを購入しましょう。',
      solution: '予算を決めて計画的に利用する、明細を定期的にチェックする'
    }
  ];

  return (
    <>
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              注意点
            </h2>
            <p className="text-lg text-gray-600">
              高還元率カードを使う際に気をつけたいポイント
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {cautions.map((caution, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md border border-gray-200"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${caution.icon} text-red-500 text-2xl`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{caution.title}</h3>
                    <p className="text-gray-600 leading-relaxed mb-3">{caution.description}</p>
                  </div>
                </div>
                <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                  <div className="flex items-start gap-2">
                    <i className="ri-lightbulb-line text-green-600 text-lg flex-shrink-0 mt-0.5"></i>
                    <div>
                      <div className="text-xs font-medium text-gray-500 mb-1">対策</div>
                      <div className="text-sm text-gray-700">{caution.solution}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl p-8 border border-blue-200">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-white text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  賢く使えば年間数万円の節約に
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  高還元率カードを正しく使えば、年間で数万円分のポイントを獲得できます。注意点を守りながら、計画的に利用しましょう。
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link 
                    to="/ranking"
                    className="px-6 py-3 bg-blue-500 text-white text-center rounded-lg hover:bg-blue-600 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                  >
                    総合ランキングを見る
                  </Link>
                  <Link 
                    to="/comparison"
                    className="px-6 py-3 bg-white text-blue-600 text-center rounded-lg border-2 border-blue-500 hover:bg-blue-50 transition-colors font-semibold whitespace-nowrap cursor-pointer"
                  >
                    カードを比較する
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4️⃣ 限定感ブロック */}
      <section className="py-12 bg-gradient-to-b from-gray-50 to-orange-50">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-8 text-white shadow-2xl">
            <div className="flex items-center gap-2 mb-4 justify-center">
              <i className="ri-fire-fill text-3xl"></i>
              <div className="px-4 py-1 bg-white text-orange-600 text-sm font-bold rounded-full whitespace-nowrap">
                今だけ！
              </div>
            </div>
            
            <h3 className="text-3xl font-bold mb-4 text-center">
              新規入会キャンペーン実施中
            </h3>
            
            <p className="text-xl text-center mb-6 opacity-95">
              最大<span className="text-4xl font-bold mx-2">25,600円</span>相当のVポイントプレゼント
            </p>
            
            <div className="bg-white/20 rounded-xl p-6 mb-6">
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-0.5"></i>
                  <span className="text-lg">新規入会＆利用でVポイントプレゼント</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-0.5"></i>
                  <span className="text-lg">対象店舗でスマホのタッチ決済利用で最大7%還元</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl mt-0.5"></i>
                  <span className="text-lg">年会費永年無料</span>
                </li>
              </ul>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/mitsui"
                className="px-8 py-4 bg-white text-orange-600 text-center rounded-lg hover:bg-gray-50 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer shadow-lg"
              >
                詳細ページを見る
              </Link>
              <a 
                href="#apply"
                className="px-8 py-4 bg-yellow-400 text-gray-900 text-center rounded-lg hover:bg-yellow-300 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer shadow-lg"
              >
                今すぐ申し込む
              </a>
            </div>
            
            <p className="text-center text-sm mt-6 opacity-90">
              ※キャンペーン期間：2026年3月31日まで
            </p>
          </div>
          
          <div className="mt-8 text-center space-y-4">
            <Link 
              to="/ranking"
              className="inline-block px-8 py-3 bg-[#FFB800] text-white rounded-lg hover:bg-[#FFA000] transition-colors font-semibold whitespace-nowrap cursor-pointer"
            >
              総合ランキングを見る
            </Link>
            <div>
              <Link 
                to="/"
                className="text-[#FFB800] hover:text-[#FFA000] font-semibold cursor-pointer"
              >
                トップページに戻る
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
